/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: ColorControlInput.tsx
 * Project: mle-client-n
 * Committed last: 2022/1/21 @ 1322
 * ---
 * Description:
 */


import { observer }               from 'mobx-react';
import { ChildControlFieldProps } from './ShapeControlView';
import { useEffect, useState }    from 'react';
import { ShapeControlWrapper }    from './ShapeControlWrapper';
import { InputGroup }             from '@blueprintjs/core';

export const ColorControlInput = observer((props: ChildControlFieldProps<string>) => {
  const [ content, setContent ] = useState('');

  useEffect(() => {
    if (!props.observableValue)
      setContent('#FFFFFF');
    else setContent(props.observableValue);
  }, [ props.observableValue ]);

  return (
    <ShapeControlWrapper label={ props.label } labelInfo={ props.labelInfo }>
      <InputGroup
        type={ 'color' }
        leftIcon={ props.leftIcon }
        className="bp4-fill min-w-1/2"
        onChange={ (e) => {
          setContent(e.target.value);
          props.setter(e.target.value);
        } }
        value={ content !== 'transparent' ? content : '#FFFFFF' }
      />
    </ShapeControlWrapper>
  );
});
